
import { supabase } from "@/integrations/supabase/client";
import { devError } from "@/utils/secureLogger";
import { secureStorage } from "@/utils/secureStorage";

export const useSignOut = () => {
  const signOut = async () => {
    try {
      // Record last logout time
      const userId = (await supabase.auth.getUser()).data.user?.id;
      if (userId) {
        localStorage.setItem(`last_logout_${userId}`, new Date().toISOString());
      }
      
      // Clear all campaign-related localStorage items before signing out
      const campaignKeys = [
        'formData',
        'devices',
        'duration',
        'selectedLocations',
        'creativeUrls',
        'startDate',
        'endDate',
        'locationCreatives',
        'mediaOwnerCreatives',
        'campaignName',
        'useLocationSpecificCreatives',
        'useMediaOwnerSpecificCreatives',
        'creatives',
        'currentStep',
        'currentCampaignId',
        'budgetCalculations',
        'showThankYou',
        'campaignMetadata'
      ];
      
      // Clear each campaign-related item
      campaignKeys.forEach(key => localStorage.removeItem(key));
      
      // Clear sensitive auth data from both localStorage and sessionStorage
      sessionStorage.removeItem('pendingVerificationEmail');
      
      // Clear any auth-related items from localStorage
      for (let i = localStorage.length - 1; i >= 0; i--) {
        const key = localStorage.key(i);
        if (key && (key.startsWith('login_attempts_') || 
                   key.startsWith('user_actions_') || 
                   key.includes('pendingCredentials') ||
                   key.includes('auth'))) {
          localStorage.removeItem(key);
        }
      }
      
      // Proceed with the actual sign out
      await supabase.auth.signOut();
      
      // Clear session cookies by reloading after a short delay
      // This ensures all client-side session data is properly cleared
      setTimeout(() => {
        window.location.href = '/';
      }, 100);
    } catch (error) {
      devError("Error during sign out:", error);
      // Still attempt to sign out from Supabase even if local cleanup fails
      await supabase.auth.signOut();
    }
  };

  return { signOut };
};
